import { RP_IDENTIFIER_TAB_KEY } from './product-identifier-v2.constants';

/**
 * Whether the Range Plan upload may run for the active tab: any tab other than Product Identifier
 * keeps its own checks, and the Product Identifier tab needs the Range Plan → Product Identifier
 * Add-Edit right.
 * @param activeTab - Key of the Range Plan tab the upload targets.
 * @param hasIdentifierAddEdit - Whether the user holds Add-Edit on Range Plan → Product Identifier.
 * @returns True when the upload is allowed.
 */
export function isIdentifierUploadAllowed(activeTab: string | null | undefined, hasIdentifierAddEdit: boolean): boolean {
  return activeTab !== RP_IDENTIFIER_TAB_KEY || hasIdentifierAddEdit;
}
